// Full-screen GLSL for the post pipeline (docs/ART-DIRECTION.md §7 post-processing). Inputs and outputs
// are linear; OutputPass applies tone mapping and the sRGB encode last.

export const FULLSCREEN_VERTEX = /* glsl */ `
varying vec2 vUv;

void main() {
  vUv = uv;
  gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
}
`

/** Base layer + (emissive layer with its bloom), composited additively. */
export const EMISSIVE_COMPOSITE_FRAGMENT = /* glsl */ `
uniform sampler2D tDiffuse;
uniform sampler2D tEmissive;

varying vec2 vUv;

void main() {
  vec4 base = texture2D(tDiffuse, vUv);
  gl_FragColor = vec4(base.rgb + texture2D(tEmissive, vUv).rgb, base.a);
}
`

/**
 * Hologram screen treatment: slowly scrolling scanlines, chromatic aberration that grows towards the screen
 * edges, and a vignette. The whole pass is disabled by "Reduce effects".
 */
export const HOLO_SCREEN_FRAGMENT = /* glsl */ `
uniform sampler2D tDiffuse;
uniform float uPixelRatio;
uniform float uScanlinePeriodPx;
uniform float uScanlinePhase;
uniform float uScanlineDepth;
uniform float uAberration;
uniform float uVignetteStart;
uniform float uVignetteEnd;
uniform float uVignetteDepth;

varying vec2 vUv;

const float TAU = 6.28318530718;

void main() {
  vec2 fromCentre = vUv - vec2(0.5);
  float edge = dot(fromCentre, fromCentre);
  vec2 shift = fromCentre * edge * uAberration;
  vec4 centre = texture2D(tDiffuse, vUv);
  vec3 colour = vec3(texture2D(tDiffuse, vUv + shift).r, centre.g, texture2D(tDiffuse, vUv - shift).b);

  float cssY = gl_FragCoord.y / uPixelRatio;
  float scan = 0.5 + 0.5 * cos(TAU * (cssY / uScanlinePeriodPx + uScanlinePhase));
  colour *= 1.0 - uScanlineDepth * scan;

  float vignette = smoothstep(uVignetteStart, uVignetteEnd, sqrt(edge));
  colour *= 1.0 - uVignetteDepth * vignette;

  gl_FragColor = vec4(colour, centre.a);
}
`
